import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Box, Button, Divider, IconButton, Link, Toolbar } from '@mui/material';
import MenuIcon from '../icons/Menu';
import HeaderLogo from './HeaderLogo';
import useAuth from '../hooks/useAuth';

function MainNavbar(props) {
  const { onSidebarMobileOpen } = props;
  const { user } = useAuth();

  return (
    <AppBar elevation={0} sx={{ backgroundColor: 'background.paper', color: 'text.secondary' }}>
      <Toolbar sx={{ minHeight: 64 }}>
        <IconButton color="inherit" onClick={onSidebarMobileOpen} sx={{ display: { md: 'none' } }} size="large">
          <MenuIcon fontSize="small" />
        </IconButton>
        <RouterLink to="/">
          <HeaderLogo height={36} sx={{ display: { md: 'inline-block', xs: 'none' } }} />
        </RouterLink>
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ alignItems: 'center', display: { md: 'flex', xs: 'none' } }}>
          <Box sx={{ mx: 2 }}>
            <Link
              sx={{ color: 'text.secondary', textDecoration: 'none' }}
              variant="body1"
              href={import.meta.env.VITE_URL_CLIENTES}
            >
              Clientes
            </Link>
          </Box>
          <Link sx={{ color: 'text.secondary', textDecoration: 'none' }} variant="body1">
            Ayuda
          </Link>
          <Divider orientation="vertical" sx={{ height: 32, mx: 2 }} />
          {
            /* eslint-disable */
            user ? (
              <Button color="primary" component={RouterLink} to="/panel" variant="contained" size="small">
                Panel de Control
              </Button>
            ) : (
              <>
                {' '}
                <Button color="primary" component={RouterLink} to="/panel" variant="contained" size="small">
                  Ingresar
                </Button>
              </>
            )
            /* eslint-enable */
          }
        </Box>
      </Toolbar>
      <Divider />
    </AppBar>
  );
}

MainNavbar.propTypes = { onSidebarMobileOpen: PropTypes.func };

export default MainNavbar;
